const schemaStepName = {
  stepWho: 'stepWho',
  stepWhereWhen: 'stepWhereWhen',
  stepWhatHappened: 'stepWhatHappened',
  stepMedicalExpenses: 'stepMedicalExpenses',
  stepOtherExpenses: 'stepOtherExpenses',
  stepPaymentContact: 'stepPaymentContact',
  stepUploads: 'stepUploads',
} as const;

export { schemaStepName };
